import Marquee from "react-fast-marquee";

// Slow editorial marquee band.
export const BrandMarquee = ({ dark = false }) => (
  <div
    data-testid="brand-marquee"
    className={`py-6 border-y ${dark ? "bg-ink border-cream/10" : "bg-sand border-ink/10"}`}
  >
    <Marquee speed={38} gradient={false} autoFill>
      {["Programme Certainty", "Delay Analysis", "Baseline Management", "Critical Path", "Look-Ahead Scheduling", "Defensible Reporting"].map((t, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display font-medium tracking-tight px-8 text-3xl md:text-4xl ${dark ? "text-cream" : "text-ink"}`}>
            {t}
          </span>
          <span className="text-gold text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
